// Initialize i18n at the very beginning, before any other module loads
import { i18n } from "@lingui/core";
import { messages as enUsMessages } from "./locales/en_US/messages";
import { messages as enCaMessages } from "./locales/en_CA/messages";
import { messages as frCaMessages } from "./locales/fr_CA/messages";

// Load all locales immediately
i18n.load({
  en_US: enUsMessages,
  en_CA: enCaMessages,
  fr_CA: frCaMessages,
});

// Get locale from URL parameter (e.g., ?locale=fr_CA)
const urlParams = new URLSearchParams(window.location.search);
const localeParam = urlParams.get("locale");

// Validate and use the locale from URL, or default to en_US
const supportedLocales = ["en_US", "en_CA", "fr_CA"];
const locale =
  localeParam && supportedLocales.includes(localeParam) ? localeParam : "en_US";

// Activate the locale
i18n.activate(locale);

// Export the ready i18n instance
export { i18n };
